import { Engine } from '../../core/Engine';
import { DeleteCommand } from '../Commands';

export class DeleteCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: DeleteCommand) {
        this.engine.delete(command.uuid);
    }
}
